import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { PopReportsService } from '../services/pop-reports.service';
import { Router } from '@angular/router';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import {
  PopReportAuthCode,
  PopulationReport,
  PopPipelineStatus,
} from '../models/PopulationReport';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';
import { TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import {
  GridComponent,
  ContextMenuService,
  ContextMenuItemModel,
} from '@syncfusion/ej2-angular-grids';
import { Title } from '@angular/platform-browser';
import { ModalService } from '../../common/services/modal.service';
import { User } from '../../common/models/user';
import { AuthService } from '../../common/services/auth.service';
import { StateService } from '../../common/services/state.service';
import { UserService } from '../../common/services/user.service';
import { ReCaptcha2Component } from 'ngx-captcha';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { Subscription, finalize, take } from 'rxjs';
// import authCodeBase64 from 'src/assets/base64ImageFiles/authCode';

@Component({
    selector: 'app-check-auth-code',
    templateUrl: './check-auth-code.component.html',
    styleUrls: ['./check-auth-code.component.css'],
    providers: [ContextMenuService],
    standalone: false
})
export class CheckAuthCodeComponent implements OnInit, AfterViewInit, OnDestroy {
  public AllPopulationReport!: PopulationReport[];
  authCodeResult = new PopReportAuthCode();
  currentUser = new User();
  public PopPipelineStatus!: PopPipelineStatus[];
  PopLineheck = true;

  public filterOptions!: FilterSettingsModel;
  public wrapSettings!: TextWrapSettingsModel;

  showPopReport = false;
  isSearching = false;
  emptymsg = false;
  showCertCodeMsg = false;
  output: any;
  form!: FormGroup;
  isRefreshing = false;
  showImage = false;
  userSignIn = false;
  h275FrontImage: any;
  h275BackImage: any;
  h692FrontImage: any;
  h692BackImage: any;
  h1000FrontImage: any;
  h1000BackImage: any;

  authCode: any;
  grade: any;
  subject: any;
  showgradeSubject: any;
  authcertcode: any;
  authcertcodelength = false;
  searchTerm: FormControl = new FormControl();
  btnAuthPopLoad = false;
  public content: string = 'You have successfully registered, Thank you.';
  page: any;
  @ViewChild('grid')
  public grid!: GridComponent;
  cardSet: any;
  sportcard: any;
  public contextMenuItems: ContextMenuItemModel[] = [
    { text: 'Report an Issue', target: '.e-content', id: 'copywithheader' },
  ];
  certificationCodePattern = '^-?[0-9]\\d*(\\-\\d{1,4})?$';
  private recaptchaWidgetId: number | null = null;
  private recaptchaSiteKey = environment.captcha.siteKey;
  captchaError = false;
  private recaptchaToken: string | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private popReportsService: PopReportsService,
    private router: Router,
    private userService: UserService,
    private titleService: Title,
    private modalService: ModalService,
    private authService: AuthService,
    private stateService: StateService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Cert Verification');
    this.buildForm();
    this.setAuthcodeValidators();
  }

  ngAfterViewInit() {
    this.initializeRecaptchaEnterprise();
  }

  ngOnDestroy() {
    if (this.recaptchaWidgetId !== null && window.grecaptcha?.enterprise) {
      try {
        window.grecaptcha.enterprise.reset(this.recaptchaWidgetId);
      } catch (e) {
        console.error('Error resetting reCAPTCHA:', e);
      }
    }
  }

  private resetRecaptcha() {
    if (this.recaptchaWidgetId !== null && window.grecaptcha?.enterprise) {
      try {
        const container = document.getElementById('recaptcha-enterprise-container');
        if (container) {
          container.style.opacity = '0.5';
        }
        window.grecaptcha.enterprise.reset(this.recaptchaWidgetId);
        this.recaptchaToken = null;
        setTimeout(() => {
          if (container) {
            container.style.opacity = '1';
          }
        }, 300);

        console.log('✅ reCAPTCHA reset successfully');
      } catch (error) {
        console.error('❌ Error resetting reCAPTCHA:', error);
      }
    }
  }

  private initializeRecaptchaEnterprise() {
    if (typeof window.grecaptcha === 'undefined' ||
      typeof window.grecaptcha.enterprise === 'undefined') {
      console.log('Waiting for reCAPTCHA Enterprise to load...');
      setTimeout(() => this.initializeRecaptchaEnterprise(), 100);
      return;
    }

    window.grecaptcha.enterprise.ready(() => {
      try {
        this.recaptchaWidgetId = window.grecaptcha.enterprise.render('recaptcha-enterprise-container', {
          sitekey: this.recaptchaSiteKey,
          action: 'CHECK_AUTHCODE',
          callback: (token: string) => {
            this.recaptchaToken = token;
            this.captchaError = false;
            console.log('✅ reCAPTCHA Enterprise completed');
          },
          'expired-callback': () => {
            this.recaptchaToken = null;
            this.captchaError = false;
            console.log('❌ reCAPTCHA Enterprise expired');
          },
          'error-callback': () => {
            this.recaptchaToken = null;
            this.captchaError = false;
            console.error('❌ reCAPTCHA Enterprise error');
          },
          theme: 'dark',
          size: 'normal'
        });
        console.log('✅ reCAPTCHA Enterprise widget initialized');
      } catch (error) {
        console.error('Error rendering reCAPTCHA Enterprise:', error);
      }
    });
  }

  buildForm() {
    this.form = this.formBuilder.group({
      authcode: new FormControl(
        '',
        Validators.compose([
          Validators.minLength(5),
          Validators.maxLength(12),
          Validators.required,
          this.validateInputValidatorFn(), // Call the wrapper function here
        ])
      ),
      grade: new FormControl(''),
      subject: new FormControl(
        '',
        Validators.compose([Validators.maxLength(15)])
      ),
    });
  }

  validateInputValidatorFn(): ValidatorFn {
    return (c: AbstractControl) => {
      let certificationCodePattern = /^\d*(?:[-,]\d{1,4})?$/;
      let StringCodePattern = /^[0-9a-zA-Z]+$/;
      return certificationCodePattern.test(c.value) ||
        StringCodePattern.test(c.value)
        ? null
        : {
          validateInput: {
            valid: false,
          },
        };
    };
  }

  setAuthcodeValidators() {
    const gradeControl = this.form.get('grade');
    const subjectControl = this.form.get('subject');
    this.form.get('authcode')!.valueChanges.subscribe((authcodeLength) => {
      var authcodecertcode = authcodeLength.charAt(0);
      if (
        authcodecertcode == 'A' ||
        authcodecertcode == 'B' ||
        authcodecertcode == 'a' ||
        authcodecertcode == 'b'
      ) {
        gradeControl!.setValidators(null);
        subjectControl!.setValidators(null);
        this.showgradeSubject = false;
      } else {
        if (authcodeLength.length > 7) {
          gradeControl?.setValidators([Validators.required]);
          subjectControl?.setValidators([Validators.required]);
          this.showgradeSubject = true;
        }
        if (authcodeLength.length === 7) {
          gradeControl!.setValidators(null);
          subjectControl!.setValidators(null);
          this.showgradeSubject = false;
        }
        if (authcodeLength.length === '') {
          gradeControl!.setValidators(null);
          subjectControl!.setValidators(null);
          this.showgradeSubject = false;
        }
      }
      gradeControl!.updateValueAndValidity();
      subjectControl!.updateValueAndValidity();
    });
  }

  contextMenuClick(args: MenuEventArgs): void {
    if (args.item.id === 'copywithheader') {
      this.grid.copy(true);
      let cardno: string =
        this.grid.contextMenuModule.row.cells[0].innerText.toString();
      let subject: string =
        this.grid.contextMenuModule.row.cells[1].innerText.toString();
      let description: string =
        this.grid.contextMenuModule.row.cells[2].innerText.toString();

      if (cardno == '') {
        cardno = 'N/A';
      }
      if (subject == '') {
        subject = 'N/A';
      }
      if (description == '') {
        description = 'N/A';
      }
      this.page = 'authcode';
      this.router.navigate([
        'pop-report/message/',
        cardno,
        this.cardSet,
        subject,
        description,
        this.sportcard,
        this.page,
      ]);
    }
  }

  CheckAuthCode() {

    if (this.form.invalid) {
      return;
    }

    if (!this.recaptchaToken) {
      this.captchaError = true;
      return;
    }

    this.showCertCodeMsg = true;
    this.showPopReport = false;
    this.isRefreshing = true;

    this.authCode = this.form.controls['authcode'].value;
    this.grade = this.form.controls['grade'].value;
    this.subject = this.form.controls['subject'].value;

    this.DataLoad(this.authCode, this.grade, this.subject, this.recaptchaToken);
  }

  DataLoad(authCode: string, grade: string, subject: string, recaptchaToken: string) {
    this.popReportsService.getPopPipelineStatus().pipe(finalize(() => { })).subscribe({
      next: (response: any) => {

        this.PopPipelineStatus = response;
        if (this.PopPipelineStatus.length >= 1) {
          this.PopLineheck = true;
          this.popReportsService.GetCertAuthCode(authCode, grade, subject, recaptchaToken)
            .pipe(finalize(() => (this.isRefreshing = false))).subscribe({
              next: (response: any) => {
                if (response != null) {
                  this.resetRecaptcha();
                  this.showImage = false;
                  this.userSignIn = false;
                  this.authCodeResult = response;
                  this.emptymsg = false;
                  if (this.authCodeResult.popResultCount == 1) {
                    this.authcertcode = this.form.controls['authcode'].value;
                    if (this.authcertcode.length > 7) {
                      this.authcertcodelength = true;
                    }
                    var AuthPopLoadcheck = this.authcertcode.charAt(0);
                    if (
                      AuthPopLoadcheck == 'A' ||
                      AuthPopLoadcheck == 'B' ||
                      AuthPopLoadcheck == 'a' ||
                      AuthPopLoadcheck == 'b'
                    ) {
                      this.btnAuthPopLoad = false;
                    } else {
                      this.btnAuthPopLoad = true;
                    }
                    this.showgradeSubject = false;
                    this.isRefreshing = false;
                    this.userService.userProfile$.subscribe((user) => {
                      this.currentUser = user;
                    });
                    //this.userService.userProfile$.subscribe(user => this.currentUser = user);
                    this.form.controls['authcode'].setValue('');
                    if (this.currentUser.id != null) {
                      this.userSignIn = true;
                    } else {
                      this.userSignIn = false;
                    }
                    if (
                      this.authCodeResult.variantGenerationState == 2 &&
                      this.authCodeResult.migrationState == 2 &&
                      this.authCodeResult.id.length >= 36
                    ) {
                      this.showImage = true;
                      this.h275FrontImage =
                        'https://sgcimagprodstorage.blob.core.windows.net/mycollections/' +
                        this.authCodeResult.id.toLowerCase() +
                        '/h275/front/' +
                        this.authCodeResult.id.toLowerCase() +
                        '.jpg';
                      this.h275BackImage =
                        'https://sgcimagprodstorage.blob.core.windows.net/mycollections/' +
                        this.authCodeResult.id.toLowerCase() +
                        '/h275/back/' +
                        this.authCodeResult.id.toLowerCase() +
                        '.jpg';

                      this.h692FrontImage =
                        'https://sgcimagprodstorage.blob.core.windows.net/mycollections/' +
                        this.authCodeResult.id.toLowerCase() +
                        '/h692/front/' +
                        this.authCodeResult.id.toLowerCase() +
                        '.jpg';
                      this.h692BackImage =
                        'https://sgcimagprodstorage.blob.core.windows.net/mycollections/' +
                        this.authCodeResult.id.toLowerCase() +
                        '/h692/back/' +
                        this.authCodeResult.id.toLowerCase() +
                        '.jpg';

                      this.h1000FrontImage =
                        'https://sgcimagprodstorage.blob.core.windows.net/mycollections/' +
                        this.authCodeResult.id.toLowerCase() +
                        '/h1000/front/' +
                        this.authCodeResult.id.toLowerCase() +
                        '.jpg';
                      this.h1000BackImage =
                        'https://sgcimagprodstorage.blob.core.windows.net/mycollections/' +
                        this.authCodeResult.id.toLowerCase() +
                        '/h1000/back/' +
                        this.authCodeResult.id.toLowerCase() +
                        '.jpg';
                    } else {
                      this.showImage = false;
                    }
                  } else if (this.authCodeResult.popResultCount! > 1) {
                    this.showgradeSubject = true;
                    this.isRefreshing = false;

                    const gradeControl = this.form.get('grade');
                    const subjectControl = this.form.get('subject');
                    gradeControl!.setValidators([Validators.required]);
                    subjectControl!.setValidators([Validators.required]);
                    gradeControl!.updateValueAndValidity();
                    subjectControl!.updateValueAndValidity();
                  }
                }
                else {
                  this.resetRecaptcha();
                  this.authcertcode = this.form.controls['authcode'].value;
                  this.emptymsg = true;
                  this.isRefreshing = false;
                  this.showgradeSubject = false;
                  this.authCodeResult.popResultCount = 0;
                  this.form.controls['authcode'].setValue('');
                  //this.form.controls['grade'].setValue('');
                  //this.form.controls['subject'].setValue('');
                  //this.form.controls['authcode'].setValue('');
                }
              },
              error: (err: any) => {
                this.resetRecaptcha();
              }
            });
        } else {
          this.isRefreshing = false;
          this.PopLineheck = false;
        }
      },
      error: (err: any) => {
      }
    });
  }

  click(cardSet: any, sport: any) {
    this.cardSet = cardSet;
    this.sportcard = sport;
    this.isSearching = true;
    this.popReportsService
      .GetallPopReport(cardSet, sport)
      .subscribe((response) => {
        this.AllPopulationReport = response;
        this.filterOptions = {
          type: 'Menu',
          operators: {
            stringOperator: [
              { value: 'contains', text: 'Contains' },
              { value: 'equal', text: 'Equal' },
            ],
            numberOperator: [],
          },
        };
        this.wrapSettings = { wrapMode: 'Both' };
        this.isSearching = false;
        if (this.AllPopulationReport.length > 0) {
          this.showPopReport = true;
        }
      });
  }

  LookUpQuestions() {
    this.router.navigate([
      '/pop-report/authcode-questions/',
      this.authcertcode,
    ]);
  }
  SaveCardToCollection() {
    var userId = this.stateService.currentUser.get().id;
    this.popReportsService
      .SaveCardToMyCollections(userId, this.authCode)
      .subscribe((response) => {
        if (response.ok) {
          this.toastr.success('Card added successfully.', 'Success', {
            progressBar: true,
            timeOut: 5000,
            progressAnimation: 'decreasing',
          });
        } else {
          if (response.error && response.error.text === 'CardAlreadyExist') {
            this.toastr.error('Card already exists.', 'Error', {
              progressBar: true,
              timeOut: 5000,
              progressAnimation: 'decreasing',
            });
          } else if (response.error && response.error.text === 'CardAdded') {
            this.toastr.success('Card added successfully.', 'Success', {
              progressBar: true,
              timeOut: 5000,
              progressAnimation: 'decreasing',
            });
          }
        }
      });
  }
  openBackImage() {
    if (
      this.authCodeResult.variantGenerationState == 2 &&
      this.authCodeResult.migrationState == 2 &&
      this.authCodeResult.id.length >= 36
    ) {
      this.modalService.open(
        'app-view-thumbnail-image',
        this.authCodeResult.id.toLowerCase()
      );
    }
  }

  openFrontImage() {
    if (
      this.authCodeResult.variantGenerationState == 2 &&
      this.authCodeResult.migrationState == 2 &&
      this.authCodeResult.id.length >= 36
    ) {
      this.modalService.open(
        'app-view-thumbnail-front-image',
        this.authCodeResult.id.toLowerCase()
      );
    }
  }

  public login(): void {
    this.authService.login();
  }
}
